export default __webpack_public_path__ + "static/media/commande.6a6a3c4b.png";